if (!customElements.get('nomitail-navigation')) {
  customElements.define('nomitail-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
      const dropdowns = [...this.querySelectorAll('.ella-style-header__menu-dropdown')];
      const closeOthers = (current) => dropdowns.forEach((details) => {
        if (details !== current) details.open = false;
      });

      dropdowns.forEach((details) => {
        const item = details.closest('[data-menu-item]');
        item.querySelector(':scope > a').addEventListener('pointerenter', (event) => {
          if (!desktop.matches || event.pointerType !== 'mouse') return;
          closeOthers(details);
          details.open = true;
        }, options);
        item.addEventListener('pointerleave', () => {
          if (desktop.matches && !item.contains(document.activeElement)) details.open = false;
        }, options);
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) details.open = false;
        }, options);
        details.addEventListener('toggle', () => {
          if (details.open) closeOthers(details);
        }, options);
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (!details || !this.contains(details)) return;
        details.open = false;
        details.querySelector('summary').focus();
        event.preventDefault();
      }, options);

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        }
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
